import { onMounted, onUnmounted } from '#imports';

function createUsePageVisibility(status: string = 'visible') {
  return (callback: () => void) => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === status) {
        callback();
      }
    };
    onMounted(() => {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    });

    onUnmounted(() => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    });
  };
}

export const usePageReactive = createUsePageVisibility('visible');
export const usePageDeactive = createUsePageVisibility('hidden');
